import React, { FC } from "react";

import { Alert } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { RelativeDate } from "../../../components/Date";
import Link from "../../../components/styled/Link";
import { Route } from "../../../store/pomeriumApi";
import TabSection from "../../account/components/TabSection";
import { SectionProps } from "./edit_sections/common";

type AppliedPolicyRowProps = {
  id: string;
  name: string;
  updatedAt: string;
  enforced: boolean;
};
const AppliedPolicyRow: FC<AppliedPolicyRowProps> = ({
  id,
  name,
  updatedAt,
  enforced,
}) => {
  return (
    <TableRow
      sx={{
        "&:last-child td": {
          borderBottom: 0,
        },
      }}
    >
      <TableCell>
        <Link to={`/app/management/policies/${id}/edit`}>{name}</Link>
      </TableCell>
      <TableCell>{enforced ? "Inherited" : "Assigned"}</TableCell>
      <TableCell align="center">
        <RelativeDate timestamp={updatedAt} />
      </TableCell>
    </TableRow>
  );
};

export const AppliedPolicies: FC<
  React.PropsWithChildren<SectionProps & { route: Route }>
> = ({ route, tabValue }) => {
  return (
    <TabSection index={"policies"} value={tabValue} title="Policies">
      {route.policies?.length > 0 || route.enforcedPolicies?.length > 0 ? (
        <>
          <TableContainer sx={{ pb: 2 }}>
            <Table size="small" aria-label="Applied Policies">
              <TableHead>
                <TableRow>
                  <TableCell>Policy</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell align="center">Last Updated</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {route.policies?.map(({ id, name, updatedAt }) => (
                  <AppliedPolicyRow
                    key={id}
                    id={id}
                    name={name}
                    updatedAt={updatedAt}
                    enforced={false}
                  />
                ))}
                {route.enforcedPolicies?.map(({ id, name, updatedAt }) => (
                  <AppliedPolicyRow
                    key={id}
                    id={id}
                    name={name}
                    updatedAt={updatedAt}
                    enforced={true}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : (
        <>
          <Alert severity="info" variant="outlined" sx={{ mt: 4 }}>
            No Policies Added.
          </Alert>
        </>
      )}
    </TabSection>
  );
};
